<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRiChengList"
      data-title="日程管理"
    >
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg">
      <div class="flex gap-x-5 p-3 border-b flex-wrap">
        <c_params title="日期">
          <template #default>
            <el-date-picker
              v-model="state.params.date"
              type="date"
              placeholder="--请选择--"
              value-format="YYYY-MM-DD"
            />
          </template>
        </c_params>
        <c_params title="类型">
          <template #default>
            <el-select v-model="state.params.type" class="!w-24">
              <el-option
                v-for="item in $base.Meeting_Schedule_Type"
                :key="item"
                :label="item.Text"
                :value="item.Key"
              ></el-option>
            </el-select>
          </template>
        </c_params>
        <c_params title="所属分会">
          <template #default>
            <el-select v-model="state.params.meeting_place_id" filterable class="!w-72">
              <template #label="{ value }">
                <div
                  v-if="fh_map.get(value)"
                  class="grid w-full gap-x-10 items-center"
                  style="grid-template-columns: 1fr auto"
                >
                  <text>{{ fh_map.get(value).name }}</text>
                  <text class="text-gray-400 text-xs">
                    {{ fh_map.get(value).hotel?.name + "-" + fh_map.get(value).hotelHall?.name }}
                  </text>
                </div>
              </template>
              <el-option
                v-for="item in state.fh_data"
                :key="item.id"
                :label="`${item.name} ${item.hotel?.name} ${item.hotelHall?.name}`"
                :value="item.id"
              >
                <div
                  class="grid w-full gap-x-10 items-center"
                  style="grid-template-columns: 1fr auto"
                >
                  <text>{{ item.name }}</text>
                  <text class="text-gray-400 text-xs">
                    {{ item.hotel?.name + "-" + item.hotelHall?.name }}
                  </text>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadFh()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </template>
        </c_params>
        <c_params title="是否全员日程">
          <template #default>
            <el-select
              v-model="state.params.is_all_personnel"
              class="!w-32"
              placeholder="--请选择--"
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </template>
        </c_params>
        <c_params title="是否需要签到">
          <template #default>
            <el-select
              v-model="state.params.is_need_signin"
              class="!w-32"
              placeholder="--请选择--"
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </template>
        </c_params>
        <c_params title="是否在网站显示">
          <template #default>
            <el-select
              v-model="state.params.is_site_show"
              class="!w-32"
              placeholder="--请选择--"
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </template>
        </c_params>
        <div class="flex">
          <el-button type="primary" icon="Search" @click="onLoad()">
            查询
          </el-button>
          <el-button type="info" link icon="Refresh" @click="onReset()">
            重置
          </el-button>
        </div>
      </div>
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        class="p-2.5"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :min-width="140">
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="时间" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <div
                  class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
                  @click="
                    $openMenu({
                      path: 'HuiYiDetailRiChengDetail',
                      title: '日程详情-' + row.name,
                      refresh: true,
                      data: {
                        id: row.id,
                        meeting_id: row.meeting_id,
                      },
                    })
                  "
                >
                  <strong>{{ row.name }}</strong>
                </div>
              </template>
              <template #bottom>
                <div class="flex items-center gap-x-2">
                  <text class="text-gray-700 text-sm">{{
                    row.start_time + " ~ " + row.end_time
                  }}</text>
                  <text class="text-gray-400 text-xs">{{ row.date }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="类型"
          prop="lx"
          :formatter="$tab_TextFormat"
          :width="120"
          align="center"
        >
          <template #default="{ row }">
            <c_status
              arrName="Meeting_Schedule_Type"
              :value="row.type"
              class="m-auto"
              showBg
              :key="row.type"
            />
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="会场" label2="位置" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.meetingPlace?.name"
              :value2="
                row.meetingPlace?.hotel?.name +
                ' - ' +
                row.meetingPlace?.hotelHall?.name
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          label="说明"
          prop="intro"
          :formatter="$tab_TextAreaFormat"
          :min-width="160"
        />
        <el-table-column label="关联议程" align="center">
          <template #default="{ row }">
            <strong class="text-green-700">
              {{ row.agenda_count }}
            </strong>
          </template>
        </el-table-column>
        <el-table-column label="全员日程" align="center">
          <template #default="{ row }">
            <c_BoolText :value="row.is_all_personnel" />
          </template>
        </el-table-column>
        <el-table-column label="需要签到" align="center">
          <template #default="{ row }">
            <el-switch
              v-model="row.is_need_signin"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              active-text="是"
              inactive-text="否"
              inline-prompt
              @change="onUpdateSignin($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="在网站显示" align="center">
          <template #default="{ row }">
            <el-switch
              v-model="row.is_site_show"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              active-text="是"
              inactive-text="否"
              inline-prompt
              @change="onUpdateSiteShow($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="success"
              :icon="Connection"
              link
              @click="
                $openMenu({
                  path: 'HuiYiDetailRiChengDetail',
                  title: '日程详情',
                  refresh: true,
                  data: {
                    id: row.id,
                    meeting_id: row.meeting_id,
                  },
                })
              "
            >
              管理
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑日程' : '新建日程'"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      :meeting_id="props.meeting_id"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { computed, onMounted, reactive } from "vue";
import {
  meeting_schedule_page,
  meeting_schedule_delete,
  meeting_schedule_updateIsNeedSignin,
  meeting_schedule_updateIsSiteShow,
} from "@/http/meeting";
import { data_getMeetingPlace } from "@/http/data";
import { onDeleteConfirm, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoadFh();
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    //获取分会
    const onLoadFh = () => {
      data_getMeetingPlace(props.meeting_id).then((res) => {
        if (res.status == 200) state.fh_data = res.data?.data?.list || [];
      });
    };

    //分会 id 索引，O(1) 查找
    const fh_map = computed(() => {
      const m = new Map();
      state.fh_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    const onLoad = () => {
      delete state.list_data;

      meeting_schedule_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    const onReset = () => {
      state.params = {
        ...new InitFormData().params,
        meeting_id: props.meeting_id,
      };
      onLoad();
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_schedule_delete, row.id, onLoad, {
        filed: "会议日程",
        name: row.name,
      });
    };

    //更新是否需要签到
    const onUpdateSignin = (value, row) => {
      ElMessageBox.confirm(
        `您确定设置该日程为${
          row.is_need_signin == 1
            ? '<strong style="color: var(--el-color-success);">需要签到</strong>'
            : '<strong style="color: var(--el-color-danger);">无需签到</strong>'
        }吗？`,
        "是否需要签到",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          meeting_schedule_updateIsNeedSignin({
            id: row.id,
            is_need_signin: value,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.is_need_signin = value ? 0 : 1;
        });
    };

    const onUpdateSiteShow = (value, row) => {
      ElMessageBox.confirm(
        `您确定设置该日程${
          row.is_site_show == 1
            ? '<strong style="color: var(--el-color-success);">在网站中显示</strong>'
            : '<strong style="color: var(--el-color-danger);">不在网站中显示</strong>'
        }吗？`,
        "是否在网站显示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          meeting_schedule_updateIsSiteShow({
            id: row.id,
            is_site_show: value,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.is_site_show = value ? 0 : 1;
        });
    };

    return {
      state,
      props,
      fh_map,
      onLoad,
      onDelete,
      onUpdateSignin,
      onUpdateSiteShow,
      onReset,
      onLoadFh,
    };
  },
};
</script>

<style lang="scss" scoped></style>
